<template>
  <AddClientAffecter />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import AddClientAffecter from "@/components/GesCom/ClientAffecter/AddClientAffecter.vue";

  export default defineComponent({
    name: "AddClientAffecterPage",
    components: {
      AddClientAffecter,
    },
  });
</script>